module.exports = __webpack_public_path__ + "media/images/c-paginate/next-049121e843f072c40cfe8dc9ead2cc57.svg";